import { createDialogProvider } from "src/components/Dialog";
import { DeleteDraftDialogContext } from "./context";
import { DeleteDraftDialog } from "./DeleteDraftDialog";

export const { DialogProvider: DeleteDraftDialogProvider } =
  createDialogProvider(
    DeleteDraftDialogContext,
    DeleteDraftDialog,
    "DeleteDraftDialog"
  );
